import { Moment } from 'moment'

export default class CosmosJobsDbRecordBase {
  public id: string // unique id
  public jobId: string
  public type: string
  public createdAt: Moment
}
